import * as React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Button } from '../../../../../../components';
import { CONDITION_TYPE } from '../../../../../Assessment';
import { APPLICATION_MODULE } from '../../../ApplicationForm';
import {
  CONDITION_MEET_TEXT,
  conditionRequirementMap,
  PAGE_TEXT,
} from './lang';
import type { FullMeetConditionStatus } from './types';
import { shouldApplicantUpdate } from './meetConditionFunctions';

export type ConditionMeetItemProps = {
  item: CONDITION_TYPE;
  title: string;
  detail: string;
  passed: boolean;
  status: FullMeetConditionStatus;
  remark: string;
  handleChangeApplicationActivated: (activatedId: APPLICATION_MODULE) => void;
};

export const ConditionMeetItem: React.FunctionComponent<
  ConditionMeetItemProps
> = (props: ConditionMeetItemProps) => {
  const {
    item,
    title,
    detail,
    passed,
    remark,
    status,
    handleChangeApplicationActivated,
  } = props;
  const theme = useTheme();
  const handleGoToUpdate = (updateType: CONDITION_TYPE) => (): void => {
    switch (updateType) {
      case CONDITION_TYPE.GENERAL_REQUIREMENT:
        handleChangeApplicationActivated(
          APPLICATION_MODULE.ACADEMIC_QUALIFICATIONS,
        );
        break;
      case CONDITION_TYPE.ENGLISH_REQUIREMENT:
        handleChangeApplicationActivated(
          APPLICATION_MODULE.LANGUAGE_QUALIFICATIONS,
        );
        break;
      case CONDITION_TYPE.OTHER_TEST_REQUIREMENT:
      case CONDITION_TYPE.OTHERS_REQUIREMENT:
        handleChangeApplicationActivated(APPLICATION_MODULE.OTHER_TESTS);
        break;

      case CONDITION_TYPE.ADDITIONAL_REQUIREMENT:
        handleChangeApplicationActivated(
          APPLICATION_MODULE.ADDITIONAL_DOCUMENTS,
        );
        break;

      default:
        break;
    }
  };
  const shouldUpdateItem = shouldApplicantUpdate(status) && !passed;
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.grey['200'],
        borderRadius: '8px',
        padding: '1rem 2rem !important',
      }}
    >
      <div className="mb-4 flex flex-row gap-6 pt-4 items-center">
        <h2 className="text-[#224295]">{title}</h2>
        <h2 className="underline">
          {/* in case the condetail is "Have or will have ...", convert it with follow map */}
          {conditionRequirementMap[detail] ?? detail}
        </h2>
      </div>

      <div className="mb-4 flex flex-row gap-6 pt-4 items-center">
        <>
          <h2 className="text-[#224295]">
            {CONDITION_MEET_TEXT.CONDITION_CHECK_RESULT}
          </h2>
          <h2 className="underline">
            {passed ? PAGE_TEXT.MEET : PAGE_TEXT.NOT_MEET}
          </h2>
        </>

        <Button
          size="small"
          variant="contained"
          onClick={handleGoToUpdate(item)}
          disabled={!shouldUpdateItem}
        >
          {CONDITION_MEET_TEXT.GO_TO_UPDATE}
        </Button>
      </div>
      <div className="pt-4">
        <div className="text-[#224295]">
          {PAGE_TEXT.MEETING_CONDITION_REMARKS}
        </div>
        <div className="p-2 underline">{remark || PAGE_TEXT.NA}</div>
      </div>
    </Box>
  );
};
